<div [id]="data.widgetId" 
  [style.height]="isFullScreen ? '65%' : (data?.chartConfig?.containerHeight || data?.containerHeight || data?.chartConfig?.height || data?.height || '700px')" 
  [style.width]="isFullScreen ? '95%' : '100%'"
  [style.max-width]="isFullScreen ? '1600px' : 'none'"
  [style.background-color]="isFullScreen ? 'white' : 'transparent'"
  [style.border]="isFullScreen ? '1px solid #ccc' : 'none'"
  [style.border-radius]="isFullScreen ? '8px' : '0'"
  [style.padding]="isFullScreen ? '15px' : '0'"
  [style.box-shadow]="isFullScreen ? '0 4px 12px rgba(0,0,0,0.05)' : 'none'"
  [style.margin]="'0 auto'">
</div>